/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useEffect, useState } from 'react';

import FocusTrap from 'focus-trap-react';

import { IconButton } from '@coursera/cds-core';

import TrackedDiv from 'bundles/page/components/TrackedDiv';
import SearchBar from 'bundles/search-common/components/searchbar/SearchBar';

const styles = {
  mobileSearchPage: css`
    position: fixed;
    top: -120vh;
    left: 0;
    background-color: transparent;
    height: 100vh;
    padding-top: 65px;
    transition: transform 0.5s ease-in-out;
    overflow: visible;
    z-index: 1;
  `,
  openMobileSearch: css`
    transform: translateY(120vh);
  `,
  mobileSearchBodyWrapper: css`
    background-color: var(--cds-color-neutral-background-primary);
    height: 100vh;
    width: 100vw;
    overflow: scroll;
  `,
  searchIcon: css`
    color: var(--cds-color-neutral-primary-weak);
  `,
};

const MobileSearchBarGridItem = () => {
  const [searchIsOpen, setSearchIsOpen] = useState(false);

  useEffect(() => {
    const bodyStyle = document.body.style;
    bodyStyle.overflow = searchIsOpen ? 'hidden' : 'visible';
    return () => {
      bodyStyle.overflow = 'visible';
    };
  }, [searchIsOpen]);

  const disableScrolling = (disabled: boolean) => {
    const bodyStyle = document?.body?.style;
    if (bodyStyle) {
      bodyStyle.overflow = disabled ? 'hidden' : 'visible';
    }
  };

  const showSearch = () => {
    setSearchIsOpen(true);
    disableScrolling(true);
  };

  const hideSearch = () => {
    setSearchIsOpen(false);
    disableScrolling(false);
  };

  return (
    <React.Fragment>
      {!searchIsOpen && <IconButton intent="search" variant="ghost" onClick={showSearch} css={styles.searchIcon} />}
      <div css={[styles.mobileSearchPage, searchIsOpen && styles.openMobileSearch]}>
        <div css={styles.mobileSearchBodyWrapper}>
          {searchIsOpen && (
            <FocusTrap active={searchIsOpen}>
              <TrackedDiv trackingName="mobile_search_contents" trackClicks={false} withVisibilityTracking>
                <SearchBar searchIsOpen={searchIsOpen} hideMobileSearchPage={hideSearch} />
              </TrackedDiv>
            </FocusTrap>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default MobileSearchBarGridItem;
